import ComentariosMinutaApi from "../api/ComentariosMinutaApi";

class ComentariosMinutaService {


    async buscar(idProcesso, idTipoMinuta, orgaoJulgador) {
        return await ComentariosMinutaApi.buscar(idProcesso, idTipoMinuta, orgaoJulgador);
    }

    async buscarMinutasComentadasDeTodosOsProcessos(idsProcesso: number[]): Promise<[number[]]> {//Promise<Map<number, number[]>> {
        const ids = [];
        idsProcesso.forEach(id => ids[id] = id);
        return await ComentariosMinutaApi.buscarMinutasComentadasDeTodosOsProcessos(Object.values(ids));
    }

    async salvar(idProcesso, idTipoMinuta, comentario) {
        return await ComentariosMinutaApi.salvar(idProcesso, idTipoMinuta, comentario);
    }

    async excluir(idProcesso: number, idTipoMinuta, numeroComentario) {
        return await ComentariosMinutaApi.excluir(idProcesso, idTipoMinuta, numeroComentario);
    }
}

export default new ComentariosMinutaService();